import Color from '@/Enums/Color.enum';
import { Tooltip, TooltipProps, styled, tooltipClasses } from '@mui/material';
import { ReactNode } from 'react';

const NoMaxWidthTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 800,
  },
});

interface IProps {
  hiddenData: ReactNode;
  label: string;
}

const HiddenDataChip = ({ hiddenData, label }: IProps) => {
  return (
    <div
      className={`flex px-3 py-1 border border-[#DADADA] rounded-full cursor-default hover:border-[#1B4332] hover:bg-[#1b43320a]`}
    >
      <NoMaxWidthTooltip
        sx={{ color: Color.Primary, fontSize: '14px', fontWeight: 600 }}
        title={hiddenData}
        placement='top'
      >
        <span>{label}</span>
      </NoMaxWidthTooltip>
    </div>
  );
};

export default HiddenDataChip;
